import type { WorkspaceAppManifest } from './workspaceManifest';

export const APP_MANIFEST = {
    appId: 'fueling-stations',
    permissionsPrefix: 'fuel',
    displayName: 'Fueling Station Management',

    navSections: [
        { key: 'dashboard',     label: 'Dashboard',     route: '/fuel/dashboard' },
        { key: 'transactions',  label: 'Transactions',  route: '/fuel/transactions' },
        { key: 'reports',       label: 'Reports',       route: '/fuel/reports' },
        { key: 'configuration', label: 'Configuration', route: '/fuel/configuration' },
    ],

    resources: [
        { key: 'fuelStationDailyEntries', label: 'Daily transactions',  navSection: 'transactions' },
        { key: 'pumpSheetReport',         label: 'Pump sheet report',   navSection: 'reports' },
        { key: 'itemLedgerReport',        label: 'Item ledger report',  navSection: 'reports' },
        { key: 'stockMovementReport',     label: 'Stock movement report', navSection: 'reports' },
        { key: 'itemStockReport',         label: 'Item stock report',   navSection: 'reports' },
        { key: 'fuelStations',            label: 'Fuel stations',       navSection: 'configuration' },
        { key: 'fuelingStationDashboard', label: 'Dashboard',           navSection: 'dashboard' },
    ],
} satisfies WorkspaceAppManifest;
